<table class="table" mat-table [dataSource]="tableDataSource" matSort multiTemplateDataRows>
  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <mat-icon class="expand-icon" [class.expanded]="isBrandExpanded(element.partnerId)">
        {{ isBrandExpanded(element.partnerId) ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
      </mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="logoUrl">
    <th mat-header-cell *matHeaderCellDef>Logo</th>
    <td mat-cell *matCellDef="let element">
      <img
        [src]="element.logoUrl"
        [alt]="element.name + ' logo'"
        class="partner-logo"
        *ngIf="element.logoUrl"
      />
      <span *ngIf="!element.logoUrl">No logo</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>

  <ng-container matColumnDef="redirectUrl">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Redirect URL</th>
    <td mat-cell *matCellDef="let element">{{ element.redirectUrl }}</td>
  </ng-container>

  <!-- Expandable row for products -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnNames.length">
      <div
        *ngIf="isBrandExpanded(element.partnerId)"
        class="expanded-content"
        [@detailExpand]="isBrandExpanded(element.partnerId) ? 'expanded' : 'collapsed'"
      >
        <app-products-table
          [brandId]="element.partnerId"
          [products]="products"
          [billingCycles]="billingCycles"
        >
        </app-products-table>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
  <tr
    class="listitem clickable-row"
    mat-row
    *matRowDef="let item; columns: columnNames"
    (click)="toggleBrandExpansion(item)"
  ></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-row"></tr>
</table>
